import { Component, Inject, LOCALE_ID } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-logged-out-layout',
  templateUrl: './logged-out-layout.component.html',
  styleUrls: ['./logged-out-layout.component.scss'],
  standalone: false,
})
export class LoggedOutLayoutComponent {
  constructor(
    private router: Router,
    @Inject(LOCALE_ID) public locale: string
  ) {}

  setLocale(locale: string) {
    window.location.href = `/${locale}${this.router.url}`;
  }
}
